exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/**\n * @Date:   2018-02-12T13:52:43+08:00\n * @Last modified time: 2018-02-28T15:07:51+08:00\n */\n.fixed-mg-btm {\n  margin-bottom: 20px;\n}\n.daily-report-action {\n  width: 240px;\n}\n.disable-daily-report input,\n.disable-daily-report textarea,\n.disable-daily-report input:hover,\n.disable-daily-report textarea:hover {\n  border: 0px;\n  background-color: white;\n  color: black;\n  cursor: default;\n}\n.UserGroupDetailLable {\n  text-align: right;\n  width: 140px;\n  margin-right: 20px;\n  line-height: 35px;\n  float: left;\n  padding-bottom: 10px;\n}\n.UserGroupDetailContent {\n  text-align: left;\n  padding-bottom: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js!./src/routes/DailyReport/style.css
// module id = 1672
// module chunks = 0